@if (isVisualVideoSection(section)) {
  <figure kb-overlay-figure
    [heading]="section.attributes.caption" [headingLevel]="section.attributes.headingLevel"
  >
    <app-plain-video
      [section]="section"
      [controls]="section.attributes.caption ? 'minimal' : 'full'"
    ></app-plain-video>
  </figure>
} @else {
  <figure kb-overlay-figure
    [heading]="section.attributes.topic" [headingLevel]="section.attributes.headingLevel"
    [abstract]="section.attributes.caption"
    [appEditorId]="section.editorIds?.src"
  >
    <kb-picture
      [appEditorId]="section.editorIds?.src"
      [appOgImage]="section.attributes"
      [picture]="imageToPicture(section.attributes, aspectRatio).sources"
      [alt]="section.attributes.alt"
      [rootColumns]="rootColumns()"
    ></kb-picture>
  </figure>
}
